<template lang="pug">
  .container-outlay-recharge-apply.container-padding(v-loading="loading")
    c-header
      template(slot="left")
        el-breadcrumb(separator="/")
          el-breadcrumb-item(to="/outlay") 营销账户管理
          el-breadcrumb-item(:to="detailURL") 营销账户详情
          el-breadcrumb-item 充值查询
    c-box
      el-form(:model="$data", label-position="right", label-width="100px")
        el-row(:gutter="10")
          el-col(:span="12")
            el-form-item(label="日期")
              el-date-picker(v-model="date", type="daterange", placeholder="选择日期范围")
          el-col(:span="12")
            el-form-item(label="状态")
              el-select(v-model="filters.biz_status")
                el-option(:value="null", label="全部")
                el-option(v-for="n in 2", :key="n", :value="n", :label="n | biz_status")
        el-form-item(label="")
          el-button(@click="setFilter", type="primary") 搜索
          el-button(@click="timeReset") 重置时间
          el-button(@click="clearFilter", v-show="hasFilter") 清除
    c-box
      el-table(:data="list", fit, v-loading="listLoading", @selection-change="selectItem", size="small", border)
        el-table-column(property="id", label="充值流水号", min-width="150", show-tooltip-when-overflow)
        el-table-column(property="create_time", label="申请时间", min-width="150", show-tooltip-when-overflow)
        el-table-column(label="充值类型", min-width="126", show-tooltip-when-overflow, v-slot="{ row }") {{ row.recharge_type | outlay_act_type }}
        el-table-column(label="充值金额", min-width="100", show-tooltip-when-overflow, v-slot="{ row }") {{ row.recharge_amount | toYuan }}
        el-table-column(label="状态", min-width="175", show-tooltip-when-overflow, v-slot="{ row }") {{ row.biz_status | biz_status }}
        el-table-column(label="操作", min-width="200", align="right", v-slot="{ row }")
          .row-toolbox
            el-button(type="primary", @click="showDetail(row)") 详情
            el-button(type="primary", @click="toConfirm(row.id)", :disabled="row.biz_status !== 1") 确认充值
      .container-pagination
        el-pagination(layout="sizes, prev, pager, next, total",
          :current-page="page", :total="total", :page-size="size", :page-sizes="[5, 10, 15, 20, 25, 50]",
          @size-change="changeListSize", @current-change="getList")

    el-dialog(title="充值审批详情", :visible.sync="detail.show", top="5%")
      el-form(:model="detail.source", label-position="right", label-width="150px")
        el-form-item(label="充值流水号") {{ detail.source.id }}
        el-form-item(label="申请时间") {{ detail.source.create_time }}
        el-form-item(label="商家名称") {{ detail.source.mch_name }} （{{ detail.source.mch_id }}）
        el-form-item(label="营销账户") {{ detail.source.outlay_account_name }}（{{ detail.source.outlay_account_id }}）
        el-form-item(label="充值类型") {{ detail.source.recharge_type | recharge_type }}
        el-form-item(label="充值金额") {{ parseFloat(detail.source.recharge_amount) >= 0 ? '+' : '-' }}{{ detail.source.recharge_amount | toYuan }}
        el-form-item(label="转账凭证")
          .img-container(v-if="detail.source.pic_array.length > 0", v-for="(p, $index) in detail.source.pic_array")
            img(:src="p", @click="$zoom(p)").img-thumbnail
          template(v-if="detail.source.pic_array.length === 0") 未上传任何图片
        el-form-item(label="备注") {{ detail.source.remark }}
        el-form-item(label="应用订单号或标识") {{ detail.source.outer_bill_id }}
        el-form-item(label="申请人") {{ detail.source.apply_user_name }}
        el-form-item(label="状态") {{ detail.source.biz_status | biz_status }}
        //- el-form-item(label="驳回原因", v-if="detail.source.status === 7 || detail.source.status === 8") {{ detail.source.reason }}
      .dialog-footer(slot="footer")
        el-button(type="primary", @click="toConfirm(detail.source.id)", :disabled="detail.source.biz_status !== 1") 确认充值
        el-button(@click="hideDetail()") 关闭
</template>

<script>
export default {
  data () {
    return {
      page:   1,
      size:   20,
      status: 0,
      list:   [],
      total:  0,
      selectedItem: [],

      listLoading:  false,

      filters: {
        status: null,
        biz_status:   null,
      },
      date:   [],
      hasFilter:    false,

      detail: {
        show:   false,
        source:   {
          pic_array:  [],
        },
      },

      loading: false,
    };
  },
  filters: {
    biz_status (source) {
      switch (source) {
        case 1:   return '待确认';
        case 2:   return '充值成功';
        default:  return source;
      }
    },
    recharge_type (source) {
      switch (source) {
        case 1:   return '营销账户余额';
        case 2:   return '积力宝';
        case 3:   return '现金券余额';
        default:  return source;
      }
    },
  },
  computed: {
    outlay_account_id () {
      return this.$route.params.outlay_account_id;
    },
    detailURL () {
      return `/outlay/${this.outlay_account_id}`;
    }
  },
  methods: {
    showDetail (row) {
      let pic_array = [];
      if (row.pic_urls && row.pic_urls.startsWith('[')) {
        pic_array = JSON.parse(row.pic_urls);
      } else if (row.pic_urls) {
        pic_array = row.pic_urls.split(',');
      }

      this.detail = {
        show:     true,
        source:   Object.assign({}, row, {
          pic_array,
        }),
      };
    },
    hideDetail () {
      this.detail = {
        show:     false,
        source:   {
          pic_array:  [],
        },
      };
    },

    toConfirm (apply_id) {
      this.$confirm('是否确认充值已成功？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        this.loading = true;
        this.$store.dispatch('CONFIRM_RECHARGE_APPLY', apply_id).then((data) => {
          this.$message({
            type:     'success',
            message:  '充值确认成功',
          });

          this.refresh();
        }).catch(({ msg }) => {
          this.$message({
            type:     'error',
            message:  `充值确认失败。${msg}`,
          });
        }).finally(() => {
          this.loading = false;
        });
      }).catch(() => {});
    },

    timeReset () {
      this.date = [];
      this.refresh();
    },
    setFilter () {
      if (this.filters.status || this.filters.biz_status || (Array.isArray(this.date) && this.date.length === 2)) {
        this.hasFilter = true;
      } else {
        this.hasFilter = false;
      }

      this.refresh();
    },
    clearFilter () {
      this.filters = {
        status:       null,
        biz_status:   null,
      };
      this.hasFilter = false;
      this.timeReset();
      this.refresh();
    },

    selectItem (val) {
      this.selectedItem = val;
    },

    refresh () {
      this.getList(this.page);
    },
    changeListSize (size = 20) {
      this.size = size;
      this.getList(1);
    },
    getList (page = 1) {
      if (!this.listLoading) {
        this.page = page;
        this.listLoading = true;
      } else {
        return;
      }

      const _filters = Object.assign({}, this.filters, {
        outlay_account_id:  this.outlay_account_id,
        start_date:         (Array.isArray(this.date) && typeof this.date[0] !== 'undefined') ? this.$dateFormatter(this.date[0]) : null,
        end_date:           (Array.isArray(this.date) && typeof this.date[1] !== 'undefined') ? this.$dateFormatter(this.date[1]) : null,
      });
      this.$store.dispatch('GET_RECHARGE_APPLY_LIST', Object.assign({
        offset:   this.size * (this.page - 1),
        limit:    this.size,
        stat:     true,
      }, _filters)).then((data) => {
        this.list = data.list;
        this.total = data.total;
      }).catch(({ msg }) => {
        this.$alert(`${msg}`, {
          type:     'error'
        });
      }).finally(() => {
        this.listLoading = false;
      });
    },
  },
  mounted () {
    this.getList(1);
  }
};
</script>